"use client";

import React from "react";
import { Check, Minus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const comparisonData = [{
  id: 1,
  feature: "Setup Cost",
  buildia: "Included in Plan",
  agency: "£2,500 - £10,000",
  agencyMuted: true
}, {
  id: 2,
  feature: "Launch Speed",
  buildia: "Minutes (AI-Powered)",
  agency: "2 - 4 Months",
  agencyMuted: true
}, {
  id: 3,
  feature: "AI Image Credits",
  buildia: "Unlimited Generation",
  agency: "Stock Photo Fees",
  agencyMuted: true
}, {
  id: 4,
  feature: "Managed Hosting",
  buildia: "High-Speed Included",
  agency: "£30 - £100/mo Extra",
  agencyMuted: true
}, {
  id: 5,
  feature: "Content Updates",
  buildia: "Prompt-to-Edit AI",
  agency: "Billed Hourly",
  agencyMuted: true
}, {
  id: 6,
  feature: "Priority Support",
  buildia: "24/7 Expert Access",
  agency: "Office Hours Only",
  agencyMuted: true
}];
export default function AiVsTraditionalDevelopment() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: tableRef,
    isVisible: isTableVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="256673" id="plan-comparison" className="py-24 dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-6 tracking-tighter">
            Webshingle vs. Traditional Agencies
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Why wait months for a website when you can vibe-code your MVP in minutes? Compare the smart way to build.
          </p>
        </div>

        <div ref={tableRef} className={`transition-all duration-1000 delay-200 ease-out ${isTableVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="bg-card rounded-2xl border border-border shadow-2xl overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow className="hover:bg-transparent border-b-border">
                  <TableHead className="w-[30%] text-lg font-bold font-default text-foreground py-6 pl-6">
                    Features
                  </TableHead>
                  <TableHead className="w-[40%] text-center bg-primary/5 border-x border-border py-6">
                    <span className="text-2xl font-bold font-default text-primary tracking-tighter">
                      WEBSHINGLE
                    </span>
                  </TableHead>
                  <TableHead className="w-[30%] text-center text-lg font-bold font-default text-muted-foreground py-6 pr-6">
                    Traditional Agency
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {comparisonData.map((item, i) => <TableRow key={item.id} data-index={i} className="hover:bg-muted/20 transition-colors border-b-border last:border-0 even:bg-white/5">
                    <TableCell className="font-semibold font-default text-base py-5 pl-6 text-foreground">
                      {item.feature}
                    </TableCell>
                    <TableCell className="text-center bg-primary/5 border-x border-border py-5">
                      <div className="flex items-center justify-center gap-2 text-primary font-bold text-base md:text-lg">
                        <Check className="size-5 shrink-0" />
                        <span className="font-default">{item.buildia}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-center py-5 pr-6">
                      <div className="flex items-center justify-center gap-2 text-muted-foreground">
                        <Minus className="size-4 shrink-0 opacity-40" />
                        <span className={`font-default ${item.agencyMuted ? "opacity-70" : ""}`}>
                          {item.agency}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>

          <div className="mt-12 text-center">
            <Button asChild size="lg" className="rounded-lg px-10 text-base h-14 shadow-xl bg-primary text-primary-foreground hover:opacity-90 transition-all">
              <Link to="/PricingPage">
                Start Your 7-Day Free Trial
              </Link>
            </Button>
            <p className="mt-4 text-sm text-muted-foreground font-default">
              No credit card required. Cancel anytime.
            </p>
          </div>
        </div>
      </div>
    </section>;
}